import { AxiosResponse } from 'axios';
import { HOTEL_AI_URL } from '../../../../config';
import { ApiResponse } from '../../../../interfaces/models/models/paginated-response.model';
import xeroAxios from '../../../../utils/axios/xero.axios';


const tryToFetchInvoices = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${HOTEL_AI_URL}/hotel-invoices/all?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${HOTEL_AI_URL}/hotel-invoices/all?page=${pageNumber}&size=${pageSize}`;
    return xeroAxios.put<any>(url, { 'accessToken': localStorage?.getItem('xeroAccessToken'), ...data || {}, });
};

const tryToAddInvoice = (data: any): Promise<AxiosResponse> => {
    return xeroAxios.post(`${HOTEL_AI_URL}/hotel-invoices`, data);
};

const tryToEditInvoice = (id: string, data: any): Promise<AxiosResponse> => {
    return xeroAxios.put(`${HOTEL_AI_URL}/hotel-invoices/${id}`, data);
};

const tryToFetchSingleInvoice = (id: string): Promise<AxiosResponse<ApiResponse<any>>> => {
    return xeroAxios.get<ApiResponse<any>>(`${HOTEL_AI_URL}/hotel-invoices/${id}`);
};

const tryToDeleteInvoice = (id: string): Promise<AxiosResponse> => {
    return xeroAxios.delete(`${HOTEL_AI_URL}/hotel-invoices/${id}`);
};

const tryToMatchPayableInvoices = (data: any): Promise<AxiosResponse> => {
    return xeroAxios.put(`${HOTEL_AI_URL}/hotel-invoices/payable/match-payments`, { 'accessToken': localStorage?.getItem('xeroAccessToken'), ...data || {} });
};

const tryToMatchReceivableInvoices = (data: any): Promise<AxiosResponse> => {
    return xeroAxios.put(`${HOTEL_AI_URL}/hotel-invoices/receivable/match-payments`, { 'accessToken': localStorage?.getItem('xeroAccessToken'), ...data || {} });
};

const tryToCategorizePayableInvoices = (data: any): Promise<AxiosResponse> => {
    return xeroAxios.put(`${HOTEL_AI_URL}/hotel-invoices/payable/categorize`, { 'accessToken': localStorage?.getItem('xeroAccessToken'), ...data || {} });
};

const tryToCategorizeReceivableInvoices = (data: any): Promise<AxiosResponse> => {
    return xeroAxios.put(`${HOTEL_AI_URL}/hotel-invoices/categorize`, { 'accessToken': localStorage?.getItem('xeroAccessToken'), ...data || {} });
};

export const InvoicesService = {
    tryToFetchInvoices,
    tryToAddInvoice,
    tryToEditInvoice,
    tryToDeleteInvoice,
    tryToFetchSingleInvoice,
    tryToMatchPayableInvoices,
    tryToMatchReceivableInvoices,
    tryToCategorizePayableInvoices,
    tryToCategorizeReceivableInvoices
};